import { Card, CardContent, Stack, Typography } from '@mui/material'
import { ContainerPositionType } from '@operations/app/api'
import { RadioOffIcon, RadioOnIcon, useMinimalsTheme } from '@tom-ui/ui'
interface Props {
  selectedOptionId: number | ContainerPositionType | undefined
  id: number | ContainerPositionType
  title: string
  subTitle?: string
  icon?: React.ReactNode
  hasError: boolean | undefined
  dataCy?: string

  onChange: (id?: number | ContainerPositionType) => void
}
export const ContainerPositionRadioOption = ({
  selectedOptionId,
  id,
  title,
  subTitle,
  icon,
  hasError,
  dataCy,
  onChange,
}: Props) => {
  const theme = useMinimalsTheme()

  const isSelected = id === selectedOptionId

  const borderColor = hasError ? theme.palette.error.main : theme.palette.grey[300]

  const handleClick = () => {
    onChange(id)
  }

  return (
    <Card
      variant='outlined'
      sx={{
        boxShadow: 'none',
        border: `1px solid ${borderColor}`,
      }}
      onClick={handleClick}
      data-cy={dataCy}
    >
      <CardContent>
        <Stack direction='row' alignItems='center' gap={theme.customSpacing.m}>
          {isSelected ? <RadioOnIcon color='primary' /> : <RadioOffIcon />}
          {icon}
          <Stack>
            <Typography variant='subtitle2'>{title}</Typography>
            {subTitle && <Typography variant='body2'>{subTitle}</Typography>}
          </Stack>
        </Stack>
      </CardContent>
    </Card>
  )
}
